<ion-fab  *ngIf="uiHelper.showBackButton" vertical="center" horizontal="end" slot="fixed">
  <ion-fab-button tappable (click)="goBack()" color="light" size="small">
    <ion-icon name="chevron-back-circle-outline"></ion-icon>
  </ion-fab-button>
</ion-fab>
